import { createModel } from '@rematch/core';
import { RootModel } from '../../models';
import { Api, ApiConfig } from '@shared/api';

export interface GroupItemInterface {
  id: string;
  group_name: string;
  edit?: boolean;
  group_users?: any;
}

type GroupState = {
  rows: Array<GroupItemInterface>;
  total: number;
};

const LpManagementGroupModule = createModel<RootModel>()({
  name: 'LpManagementGroupModule',
  state: {
    rows: [],
    total: 30,
  } as any as GroupState,
  reducers: {
    updateState(state, payload: GroupState) {
      return {
        ...state,
        ...payload,
      };
    },
    setPerPage(state, payload: number) {
      return {
        ...state,
        page_size: payload,
      };
    },
    setPage(state, payload: number) {
      return {
        ...state,
        page: payload,
      };
    },
    setList(state, payload: GroupItemInterface[]) {
      return {
        ...state,
        rows: payload,
      };
    },
    // updateGroupName(state, payload: { group_id: string; group_name: string }) {
    //   const newList = state.rows.map((item) => {
    //     const newItem = Object.assign({}, item);
    //     if (item.id === payload.group_id) newItem.group_name = payload.group_name;
    //     return newItem;
    //   });
    //   return {
    //     ...state,
    //     rows: newList,
    //   };
    // },
  },
  effects: (dispatch) => ({
    async createGroup(payload: { group_name: string }) {
      await Api.request(ApiConfig.createGroup, payload);
    },
    async deleteGroup(id: string) {
      await Api.request(ApiConfig.deleteGroup, { group_id: id });
    },
    async getAllGroups(payload: { page?: number; page_size?: number; key?: string }) {
      const response = await Api.request(ApiConfig.getAllGroups, { ...payload });
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch.LpManagementGroupModule.updateState(response);
    },
    async updateGroupName(payload: { group_id: string; group_name: string }) {
      await Api.request(ApiConfig.updateGroupName, { group_id: payload.group_id, group_name: payload.group_name });
    },
    async deleteGroupUserAccount(payload: { group_id: string; user_id: string }) {
      await Api.request(ApiConfig.deleteGroupUserAccount, payload);
    },
    async addGroupUser(payload: { user_ids: string; group_id: string }) {
      await Api.request(ApiConfig.addGroupUser, { ...payload });
    },
  }),
});

export default LpManagementGroupModule;
